import {
  GET_LIST_DANHSACHTAISAN,
  GET_LIST_DANHSACHTAISAN_SUCCESS,
  GET_LIST_DANHSACHTAISAN_FAILURE,
  GET_LIST_TAISAN,
  GET_LIST_TAISAN_SUCCESS,
  GET_LIST_TAISAN_FAILURE,
  UPDATE_SEARCHTDATA_TAISAN,
} from "./actionTypes";

export const getListDanhSachTaiSan = (dataSearch) => ({
  type: GET_LIST_DANHSACHTAISAN,
  dataSearch,
});

export const getListDanhSachTaiSanSuccess = (data) => ({
  type: GET_LIST_DANHSACHTAISAN_SUCCESS,
  payload: data,
});

export const getListDanhSachTaiSanFailure = () => ({
  type: GET_LIST_DANHSACHTAISAN_FAILURE,
});

export const getListTaiSan = (dataSearch) => ({
  type: GET_LIST_TAISAN,
  dataSearch,
});
export const getListTaiSanSuccess = (data) => ({
  type: GET_LIST_TAISAN_SUCCESS,
  payload: data,
});
export const getListTaiSanFailure = (dataSearch) => ({
  type: GET_LIST_TAISAN_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_TAISAN,
  payload: data,
});
